import {gsap} from "gsap";
import EmitEvent, {HT_RESIZE, PAGE_LOADED} from "../../../../libs/emit-event";
import services from "../../../../libs/services";
import {Drag} from "../../../system/drag/drag";
import {ProjectItemMobile} from "./project-item-mobile";
import {isScreenMobile} from "../../../../libs/helper";

export class ShortcodeProjectsPageMobile {

    constructor() {

        this.DOM = {main: document.querySelector('.js-projectsPage')};
        if (!this.DOM.main) return;
        this.DOM.dragger = this.DOM.main.querySelector('.js-projectsPage_wrapper');
        this.DOM.container = this.DOM.main.querySelector('.js-projectsPage_container');
        this.DOM.borderActive = this.DOM.main.querySelector('.js-projectsPage_thumbsActive');
        this.DOM.thumbnailItems = this.DOM.main.querySelectorAll('.js-projectsPage_thumbs_item');

        this.projects = [];
        this.styles = {};
        this.dragValue = 0;
        this.itemActive = 1;

        //binds this
        this.onDragging = this.onDragging.bind(this);
        this.getProp = this.getProp.bind(this);
        this.htResize = this.htResize.bind(this);
        this.pageLoaded = this.pageLoaded.bind(this);
        this.onHoldSlide = this.onHoldSlide.bind(this);
        this.onLeaveSlide = this.onLeaveSlide.bind(this);
        this.onMouseMoving = this.onMouseMoving.bind(this);
        this.getDragValue = this.getDragValue.bind(this);

        this.init();
        this.bindEvent();
    }

    init() {

        const DomItems = document.querySelectorAll('.js-projectPageItem');
        const DomHeading = document.querySelectorAll('.js-projectsPage_names_item');

        if (DomItems.length > 0) {

            const images = [];
            DomItems.forEach((item, index) => {
                const projectItem = new ProjectItemMobile({
                    el: item,
                    elHeading: DomHeading[index],
                    index,
                    indexActive: this.itemActive,
                    getDragValue: this.getDragValue
                });
                this.projects.push(projectItem);
            });

            this.drag = new Drag({
                el: this.DOM.dragger,
                animationIn: null,
                updateDragValue: this.onDragging,
                updateProp: this.getProp,
                onHold: this.onHoldSlide,
                onUp: this.onLeaveSlide,
                onMouseMoving: this.onMouseMoving
            });
        }
    }

    getDragValue() {
        return this.drag.style.transition.current;
    }

    onHoldSlide() {
        gsap.killTweensOf(this.drag.style.transition);
        this.projects[this.itemActive].animationTextOut();
        this.DOM.borderActive.classList.add('on-hover');
        this.DOM.container.style.pointerEvents = 'none';
    }

    onLeaveSlide() {

        this.itemActive = Math.min(Math.max(this.itemActive, 0), (this.projects.length - 1));
        this.projects[this.itemActive].animationTextIn();
        this.DOM.container.style.pointerEvents = null;

        gsap.to(this.drag.style.transition, {
            last: -this.projects[this.itemActive].getFocus(),
            duration: 1,
            ease: 'power3.out',
        });
        this.DOM.borderActive.classList.remove('on-hover');

    }

    getProp() {
        this.drag.style.transition.maxDrag = -1;
        this.styles.triggerStart = services.winSize.width / 2 - 100;
        this.styles.triggerEnd = services.winSize.width / 2 + 100;
    }

    onDragging(current) {
        if (isScreenMobile()) return;
        this.projects.forEach((item, index) => {
            item.dragging(current);
        });
    }

    onMouseMoving(last) {

        if (isScreenMobile()) return;

        this.projects.forEach((item, index) => {
            if (item.draggingTestActive(last, this.styles) && index !== this.itemActive) {
                this.itemActive = index;
                const {left} = this.DOM.thumbnailItems[this.itemActive].getBoundingClientRect();
                gsap.to(this.DOM.borderActive, {x: left, ease: 'power3.out', duration: .4});
            }
        });
    }


    pageLoaded() {
        this.getProp();

        this.drag.style.transition.last = this.drag.style.transition.current = -this.projects[this.itemActive].getFocus();
        const {left} = this.DOM.thumbnailItems[this.itemActive].getBoundingClientRect();

        gsap.set(this.DOM.borderActive, {x: left});

        setTimeout(() => {
            this.projects[this.itemActive].animationTextIn();
        }, 400);
    }

    htResize() {
        if (isScreenMobile()) {
            this.drag.style.transition.last = this.drag.style.transition.current = 0;
            this.projects.forEach((item, index) => {
                item.clearDragging();
            });
        } else {
            this.drag.style.transition.last = -this.projects[this.itemActive].getFocus();
            this.drag.renderDrag();

            const {left} = this.DOM.thumbnailItems[this.itemActive].getBoundingClientRect();
            gsap.set(this.DOM.borderActive, {x: left});
        }
    }

    itemOnclick(key) {

        if (this.itemActive === key) return;

        this.projects[this.itemActive].animationTextOut();

        this.itemActive = key;
        this.onLeaveSlide();

        const {left} = this.DOM.thumbnailItems[this.itemActive].getBoundingClientRect();
        gsap.to(this.DOM.borderActive, {x: left, ease: 'power3.out', duration: .4});

    }

    bindEvent() {
        EmitEvent.on(HT_RESIZE, this.htResize);
        EmitEvent.on(PAGE_LOADED, this.pageLoaded);
        this.DOM.thumbnailItems.forEach((item, key) => {
            item.addEventListener('click', () => this.itemOnclick(key));
        });
    }

    removeEvent() {
        EmitEvent.off(HT_RESIZE, this.htResize);
        EmitEvent.off(PAGE_LOADED, this.pageLoaded);
        if (this.drag) {
            this.drag.removeEvent();
        }
        if (this.projects) {
            this.projects.forEach(item => {
                item.removeEvent();
            });
        }
    }
}